class PromoBlock extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
    
    this.desktopHeightPixelsIfFullWidth = this.getAttribute('data-desktop-height-pixels-if-full-width');
    this.grid = document.querySelector('ul.product-grid');
    this.promoMediaMobile = this.querySelector('.promo-media-mobile');
    this.promoMediaDesktop = this.querySelector('.promo-media-desktop');
    this.desktopWidthGrid = this.parentElement.getAttribute('data-desktop-width-grid');
    this.hasVideoOnMobile = this.hasAttribute('data-has-video-on-mobile');
    this.hasVideoOnDesktop = this.hasAttribute('data-has-video-on-desktop');
    this.startDate = this.getAttribute('data-start-date');
    this.endDate = this.getAttribute('data-end-date');
    this.href = this.getAttribute('data-href');
    this.handleMobileHeightPixels();
    document.addEventListener('product-grid-view-changed', () => {
      this.handleMobileHeightPixels();
    });
    this.observeGrid();
    this.addClickHandler();
    this.handleDate();
	}

  handleDate() {
    if (!this.startDate || !this.endDate) {
      this.parentElement.classList.remove('d-none');
      return;
    };
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    
    const today = new Date();
    if (today >= startDate && today <= endDate) {
      this.parentElement.classList.remove('d-none');
    }
  }

  addClickHandler() {
    if (!this.href) return;
    this.addEventListener('click', () => {
      window.location.href = this.href;
    });
  }
  
  handleMobileHeightPixels() {
    const productGridView = document.querySelector('ul.product-grid')?.getAttribute('product-grid-view');
    const mobileHeightPixelsIfFullWidth = this.getAttribute('data-mobile-height-pixels-if-full-width');
    
    if (!productGridView || !mobileHeightPixelsIfFullWidth || !this.promoMediaMobile) return;

    let isPromoBlockFullWidth = false;
    if (
      productGridView === 'mobile-single' ||
      (productGridView === 'default' && this.parentElement?.classList.contains('mobile-width-grid-2'))
    ) isPromoBlockFullWidth = true;

    if (isPromoBlockFullWidth && window.innerWidth < 750) {
      this.promoMediaMobile.style.height = this.hasVideoOnMobile ? '100%' : 'auto';
      this.style.height = `${mobileHeightPixelsIfFullWidth}px`;
    } else {
      this.promoMediaMobile.style.height = '100%';
      this.style.height = '100%';
    }
    
  }

  observeGrid() {
    if (!this.grid) return;
    const observer = new ResizeObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Adjust the height of promo block if it takes full width on desktop
        if (window.innerWidth >= 750) {
          const columnsInGrid = window.getComputedStyle(mutation.target)?.gridTemplateColumns?.split(' ')?.length;
          let desktopWidthGridNumber = null;
          if (this.desktopWidthGrid) desktopWidthGridNumber = Number(this.desktopWidthGrid);
          if (desktopWidthGridNumber && desktopWidthGridNumber >= columnsInGrid) {
            this.style.height = `${this.desktopHeightPixelsIfFullWidth}px`;
            this.promoMediaDesktop.style.height = this.hasVideoOnDesktop ? '100%' : 'auto';
          } else {
            this.style.height = '100%';
            this.promoMediaDesktop.style.height = '100%';
          }
        }
      });
    });
    observer.observe(this.grid, { attributes: true });
  }
}

if (!customElements.get('promo-block')) {
	customElements.define('promo-block', PromoBlock);
}


